import { toast } from "react-toastify";
import axios from "axios";
import settings from "utils/settings";
import defaultErrorHandler from "actions/global/default-error-handler";

import {
  TRIP_ACTIVE_LOADING,
  TRIP_ACTIVE_ERROR,

  TRIP_ACTIVE_FINISH,
  TRIP_ACTIVE_FILTERS,
  TRIP_ACTIVE_LIST,
  // TRIP_ACTIVE_ADD,
  // TRIP_ACTIVE_UPDATE,
  // TRIP_ACTIVE_DELETE
} from "./constants";
import { requestCommonFilters, requestCommonSearch } from "../common/requests";

const apiUrl = `${settings.apiUrl}api/trip/active`;

export const setLoading = (status) => ({
  type: TRIP_ACTIVE_LOADING,
  payload: status
});

export const search = (page = 0, size = 20, sort = "id,asc", criteria = []) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch("trip/active", page, size, sort, criteria)
    .then(response => {
      dispatch({
        type: TRIP_ACTIVE_LIST,
        payload: response
      });
    })
    .catch(error => {
      dispatch(defaultErrorHandler(error, TRIP_ACTIVE_ERROR));
    });
};

export const getFilters = () => dispatch => {
  dispatch(setLoading(true));
  requestCommonFilters("trip/active")
    .then((response) => {
      dispatch({
        type: TRIP_ACTIVE_FILTERS,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, TRIP_ACTIVE_ERROR));
    });
};

export const finish = (id) => dispatch => {
  dispatch(setLoading(true));
  axios.patch(`${apiUrl}/${id}`)
    .then((response) => {
      dispatch({
        type: TRIP_ACTIVE_FINISH,
        payload: id
      });
      if (response.data.message === "SUCCESS") {
        toast("Trip Finished", { type: toast.TYPE.SUCCESS });
      } else {
        toast("Can't finish trip. Something went wrong.", { type: toast.TYPE.ERROR });
      }
    })
    .catch((error) => {
      dispatch(defaultErrorHandler(error, TRIP_ACTIVE_ERROR));
    });
};



// WEBPACK FOOTER //
// ./src/actions/trip-active/actions.js